import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EImgIcons, EAppIcons, EPhotos, EAppIconsStandard } from 'src/app/classes/def/app/icons';

@Component({
  selector: 'stripe-card',
  templateUrl: './stripe-card.component.html',
  styleUrls: ['./stripe-card.component.scss']
})
export class StripeCardComponent implements OnInit, OnDestroy {
  imgIcons = EImgIcons;
  appIcons = EAppIcons;
  appIconsStandard = EAppIconsStandard;

  stripeBadge: string = EPhotos.stripeBadge;

  descriptionDisp: string = "";
  titleDisp: string = "Alternative checkout";
  titleDispKey: string = "connect:labels.alternativeCheckout";
  checkoutDisp: string = "";

  footerDisp: string = "<p>Also available as a standalone product on Leplace World</p>";
  footerDispKey: string = "connect:labels.alsoAvailableProductLPW";

  loaded: boolean = false;

  @Input()
  price: string;

  @Input()
  promo: string;

  @Input()
  noLogo: boolean;

  @Output() checkout = new EventEmitter<boolean>();

  constructor(

  ) {

  }

  ngOnInit() {
    this.getPriceDisp();
  }

  ngOnDestroy() {

  }

  getPromoDisp() {
    if (this.promo != null && this.promo != "") {
      return "Promo: " + this.price + " -> " + this.promo;
    }
    return this.price;
  }

  getPriceDisp() {
    this.checkoutDisp = "Checkout (" + this.price + ")";
    if (this.promo != null && this.promo != "") {
      this.checkoutDisp = "Checkout (" + this.price + " -> " + this.promo + ")";
    }
  }

  tapCheckout() {
    this.checkout.emit(true);
  }
}
